import type { ReactNode } from 'react';
import styles from './ViewFadeIn.module.css';

type Props = {
  children: ReactNode;
  className?: string;
  lift?: boolean;
};

export function ViewFadeIn({ children, className, lift = true }: Props) {
  const classes = [styles.root, lift ? styles.lift : '', className].filter(Boolean).join(' ');

  return <div className={classes}>{children}</div>;
}
